import logoBlack from "@/assets/logo-mark-black.webp";
import logoWhite from "@/assets/logo-mark-white.webp";

/**
 * 2AM Hospitality logo.
 * The source image already contains the mark + wordmark ("2AM Hospitality"),
 * so we render the full image directly. The "icon" variant crops to the mark
 * only via aspect-ratio + object-position.
 *
 * - Adaptive: black logo in light theme, white logo in .dark scope.
 * - `variant="full"`  → mark + wordmark (used in header / footer)
 * - `variant="icon"`  → mark only (compact / mobile)
 */
export function Logo({
  variant = "full",
  className = "",
  priority = false,
}: {
  variant?: "full" | "icon";
  className?: string;
  /** When true, marks the image as high priority (use for above-the-fold header logo). */
  priority?: boolean;
}) {
  const loadingAttr = priority ? "eager" : "lazy";
  const fetchPriorityAttr = priority ? "high" : "auto";

  if (variant === "icon") {
    return (
      <span
        className={`relative inline-block h-9 w-9 shrink-0 overflow-hidden ${className}`}
        aria-label="2AM Hospitality"
      >
        <img
          src={logoBlack}
          alt=""
          aria-hidden
          draggable={false}
          width={36}
          height={36}
          loading={loadingAttr}
          fetchPriority={fetchPriorityAttr}
          decoding="async"
          className="absolute left-0 top-0 h-full w-auto max-w-none object-contain object-left"
          style={{ height: "100%" }}
        />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center ${className}`}
      aria-label="2AM Hospitality"
    >
      <img
        src={logoBlack}
        alt="2AM Hospitality"
        draggable={false}
        width={140}
        height={40}
        loading={loadingAttr}
        fetchPriority={fetchPriorityAttr}
        decoding="async"
        className="h-10 w-auto object-contain"
      />
    </span>
  );
}

// Keep legacy exports so older imports continue to compile.
export const LogoMark = ({ className = "h-8 w-8" }: { className?: string }) => (
  <Logo variant="icon" className={className} />
);
export const LOGO_ICON_URL = logoBlack;
